import(/* webpackMode: "eager" */ "/var/www/vhosts/castly.nl/httpdocs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/var/www/vhosts/castly.nl/httpdocs/src/components/marketing/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroMiniTv"] */ "/var/www/vhosts/castly.nl/httpdocs/src/components/marketing/hero-mini-tv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pricing"] */ "/var/www/vhosts/castly.nl/httpdocs/src/components/marketing/pricing.tsx");
